import api from './client';

export const legalApi = {
  getTerms: () => api.get('/legal/terms'),
};
